import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';
import { BEACON_SUBTABS } from 'src/components/BeaconV2Components/GenericSidebarNav/useBeaconRoutes';
import PortfolioSettings from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/PortfolioBuilder/PortfolioSettings';
import PortfolioCampaigns from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/PortfolioBuilder/PortfolioCampaigns';
import PortfolioConfirmation from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/PortfolioBuilder/PortfolioConfirmation';
import AdMetric from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/AdMetric';
import IneligibleEntities from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/Ineligible';
import Optimization from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/Optimizations';
import BudgetEntity from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/BudgetBuilder/BudgetEntity';
import BudgetConfirmation from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/BudgetBuilder/BudgetConfirmation';
import BudgetAllocation from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/BudgetBuilder/BudgetAllocation';
import AdvertisingRules from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/Rules/RulesSummary';
import RulesDetails from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/Rules/RulesDetails';

const getAdvertisingPageLayout = ({ metricType }) => {
  switch (metricType) {
    case BEACON_SUBTABS.AD_METRICS:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.CONTENT_SUMMARY,
            CustomComponent: AdMetric,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.INELIGIBLE:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.CONTENT_UTILIZATION,
            CustomComponent: IneligibleEntities,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.OPTIMIZATIONS:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.OPTIMIZATIONS,
            CustomComponent: Optimization,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.BUDGET_ENTITY:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.BUDGET_ENTITY,
            CustomComponent: BudgetEntity,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.BUDGET_ALLOCATION:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.BUDGET_ALLOCATION,
            CustomComponent: BudgetAllocation,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.BUDGET_CONFIRMATION:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.BUDGET_CONFIRMATION,
            CustomComponent: BudgetConfirmation,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.PORTFOLIO_SETTINGS:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.PORTFOLIO_SETTINGS,
            CustomComponent: PortfolioSettings,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };
    case BEACON_SUBTABS.RULES_SUMMARY:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.RULES_SUMMARY,
            CustomComponent: AdvertisingRules,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };
    case BEACON_SUBTABS.RULES_DETAILS:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.RULES_DETAILS,
            CustomComponent: RulesDetails,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.PORTFOLIO_CAMPAIGNS:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.PORTFOLIO_CAMPAIGNS,
            CustomComponent: PortfolioCampaigns,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };
    case BEACON_SUBTABS.PORTFOLIO_CONFIRMATION:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.PORTFOLIO_CONFIRMATION,
            CustomComponent: PortfolioConfirmation,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };
    default:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.CONTENT_SUMMARY,
            CustomComponent: AdMetric,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };
  }
};

export default getAdvertisingPageLayout;
